import { render, staticRenderFns } from "./managedInstructionAssignmentsTable.vue?vue&type=template&id=347a4838&scoped=true"
import script from "./managedInstructionAssignmentsTable.vue?vue&type=script&lang=js"
export * from "./managedInstructionAssignmentsTable.vue?vue&type=script&lang=js"
import style0 from "./managedInstructionAssignmentsTable.vue?vue&type=style&index=0&id=347a4838&prod&scoped=true&lang=css"
import style1 from "./managedInstructionAssignmentsTable.vue?vue&type=style&index=1&id=347a4838&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347a4838",
  null
  
)

export default component.exports